import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { MapPickerParams } from '../map-picker-dialog/map-picker-dialog-service';
import { AnyHandler } from 'src/app/types/@types/sl-v-types';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export interface LayerPickerParams {
	handler: AnyHandler;
}

@Injectable({
	providedIn: 'root'
})
export class LayerPickerDialogService {
	public request$: Subject<LayerPickerParams> = new Subject();

	constructor() { }
	Show(
		handler: AnyHandler
	) {
		const params: LayerPickerParams = {
			handler: (handler)
		};
		this.request$.next(params);
	}

}
